import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { Route as rootRoute } from "./__root";

// El contenido real vive en portal-page.tsx y se descarga aparte (code-split) — así
// los visitantes del sitio público (/, /nosotros, etc.) no bajan este bundle.
export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/portal",
  component: lazyRouteComponent(() => import("./portal-page"), "PortalPage"),
});
